import Currency from "./currency";
import { withProperties } from "../utils";

function __formatAmountNumeric__(amount, rounded = false) {
  const precision = rounded === true ? 0 : 2;

  return Number(
    new Intl.NumberFormat("en-US", {
      style: "decimal",
      useGrouping: false,
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    }).format(amount)
  );
}

function __formatAmountString__(amount, rounded = false) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    useGrouping: true
  }).format(__formatAmountNumeric__(amount, rounded));
}

function __parseAmount__(value) {
  value = Number(typeof value === "string" ? value.trim() : value);

  if (Number.isNaN(value) || value < 0) {
    throw new TypeError("Invalid amount.");
  }

  return value;
}

function __parseCurrency__(value, list) {
  try {
    const currency = Currency.validate({ currency: value, support: false });

    list = [].concat(list).filter(Boolean);
    list = list.length ? list : Currency.SUPPORTED;

    if (list.indexOf(currency) >= 0) return currency;
  } catch (e) {}

  throw new TypeError("Invalid currency.");
}

function __amountPropertyDescriptor__(property) {
  return function (amount) {
    try {
      this[property] = __parseAmount__(amount);
    } finally {
      return this;
    }
  };
}

// Amount Class
function Amount(amount, currency) {
  this.base = __parseAmount__(amount);
  this.currency = __parseCurrency__(currency);
  this.usesRounded = Currency.ROUNDED.indexOf(this.currency) >= 0;

  Object.defineProperty(this, "computed", {
    configurable: true,
    enumerable: true,
    get() {
      return this.base;
    }
  });
}

// Augment Amount prototype
Object.defineProperties(Amount.prototype, {
  valueOf: {
    enumerable: true,
    value: function () {
      return __formatAmountNumeric__(this.computed, this.usesRounded);
    }
  },

  toString: {
    enumerable: true,
    value: function () {
      return `${this.currency} ${__formatAmountString__(
        this.computed,
        this.usesRounded
      )}`;
    }
  }
});

// ChargeAmount Class
function ChargeAmount(amount, currency) {
  Amount.call(this, amount, currency);

  this.fee = 0;
  this.discount = 0;

  Object.defineProperty(this, "computed", {
    configurable: true,
    enumerable: true,
    get() {
      return this.base + this.fee - this.discount;
    }
  });
}

// Augment ChargeAmount prototype
ChargeAmount.prototype = withProperties(Object.create(Amount.prototype), {
  constructor: ChargeAmount,
  updateFee: __amountPropertyDescriptor__("fee"),
  updateDiscount: __amountPropertyDescriptor__("discount")
});

export {
  Amount,
  ChargeAmount,
  __parseAmount__ as parseAmount,
  __parseCurrency__ as parseCurrency,
  __formatAmountNumeric__ as formatAmount,
  __formatAmountString__ as formatAmountAsString
}
